import { render, staticRenderFns } from "./CoberturaForm.vue?vue&type=template&id=11a1f6e0&scoped=true&"
import script from "./CoberturaForm.vue?vue&type=script&lang=js&"
export * from "./CoberturaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a1f6e0",
  null
  
)

export default component.exports